module.exports = __webpack_public_path__ + "static/media/sbs.f0635942.png";